'use client';

import { useEffect, useRef } from 'react';
import { countUp } from '@/utils/gsap';

export function useCountUp(items, triggerRef) {
  const refs = useRef([]);
  useEffect(() => {
    const tweens = items.map((item, i) =>
      countUp(refs.current[i], item.countTo, {
        prefix: item.prefix || '',
        suffix: item.suffix || '',
        decimals: item.decimals || 0,
        sep: item.sep,
        delay: item.delay,
        trigger: triggerRef?.current,
      })
    );
    return () => tweens.forEach((t) => t?.kill());
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return refs;
}
